import React, { useEffect, useState } from "react";
// import ReCAPTCHA from "react-google-recaptcha";
import { Link, useNavigate } from "react-router-dom";
import {
  passwordLength,
  validateEmail,
  validateName,
  validatePassword,
  validInternationalPhone
} from "../../utils/common";
import { registerApi, trackIP } from "../../api/methods-marketplace";
import { addToast, Button, Input, Textarea } from "@heroui/react";
import InputPhone from "../../components/input-phone";
import Logo from "../../images/logo.png";

const EyeSlashFilledIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      height="1em"
      role="presentation"
      viewBox="0 0 24 24"
      width="1em"
      {...props}
    >
      <path
        d="M21.2714 9.17834C20.9814 8.71834 20.6714 8.28834 20.3514 7.88834C19.9814 7.41834 19.2814 7.37834 18.8614 7.79834L15.8614 10.7983C16.0814 11.4583 16.1214 12.2183 15.9214 13.0083C15.5714 14.4183 14.4314 15.5583 13.0214 15.9083C12.2314 16.1083 11.4714 16.0683 10.8114 15.8483C10.8114 15.8483 9.38141 17.2783 8.35141 18.3083C7.85141 18.8083 8.01141 19.6883 8.68141 19.9483C9.75141 20.3583 10.8614 20.5683 12.0014 20.5683C13.7814 20.5683 15.5114 20.0483 17.0914 19.0783C18.7014 18.0783 20.1514 16.6083 21.3214 14.7383C22.2714 13.2283 22.2214 10.6883 21.2714 9.17834Z"
        fill="currentColor"
      />
      <path
        d="M14.0206 9.98062L9.98062 14.0206C9.47062 13.5006 9.14062 12.7806 9.14062 12.0006C9.14062 10.4306 10.4206 9.14062 12.0006 9.14062C12.7806 9.14062 13.5006 9.47062 14.0206 9.98062Z"
        fill="currentColor"
      />
      <path
        d="M18.25 5.74969L14.86 9.13969C14.13 8.39969 13.12 7.95969 12 7.95969C9.76 7.95969 7.96 9.76969 7.96 11.9997C7.96 13.1197 8.41 14.1297 9.14 14.8597L5.76 18.2497H5.75C4.64 17.3497 3.62 16.1997 2.75 14.8397C1.75 13.2697 1.75 10.7197 2.75 9.14969C3.91 7.32969 5.33 5.89969 6.91 4.91969C8.49 3.95969 10.22 3.42969 12 3.42969C14.23 3.42969 16.39 4.24969 18.25 5.74969Z"
        fill="currentColor"
      />
      <path
        d="M14.8581 11.9981C14.8581 13.5681 13.5781 14.8581 11.9981 14.8581C11.9381 14.8581 11.8881 14.8581 11.8281 14.8381L14.8381 11.8281C14.8581 11.8881 14.8581 11.9381 14.8581 11.9981Z"
        fill="currentColor"
      />
      <path
        d="M21.7689 2.22891C21.4689 1.92891 20.9789 1.92891 20.6789 2.22891L2.22891 20.6889C1.92891 20.9889 1.92891 21.4789 2.22891 21.7789C2.37891 21.9189 2.56891 21.9989 2.76891 21.9989C2.96891 21.9989 3.15891 21.9189 3.30891 21.7689L21.7689 3.30891C22.0789 3.00891 22.0789 2.52891 21.7689 2.22891Z"
        fill="currentColor"
      />
    </svg>
  );
};

const EyeFilledIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      height="1em"
      role="presentation"
      viewBox="0 0 24 24"
      width="1em"
      {...props}
    >
      <path
        d="M21.25 9.14969C18.94 5.51969 15.56 3.42969 12 3.42969C10.22 3.42969 8.49 3.94969 6.91 4.91969C5.33 5.89969 3.91 7.32969 2.75 9.14969C1.75 10.7197 1.75 13.2697 2.75 14.8397C5.06 18.4797 8.44 20.5597 12 20.5597C13.78 20.5597 15.51 20.0397 17.09 19.0697C18.67 18.0897 20.09 16.6597 21.25 14.8397C22.25 13.2797 22.25 10.7197 21.25 9.14969ZM12 16.0397C9.76 16.0397 7.96 14.2297 7.96 11.9997C7.96 9.76969 9.76 7.95969 12 7.95969C14.24 7.95969 16.04 9.76969 16.04 11.9997C16.04 14.2297 14.24 16.0397 12 16.0397Z"
        fill="currentColor"
      />
      <path
        d="M11.9984 9.14062C10.4284 9.14062 9.14844 10.4206 9.14844 12.0006C9.14844 13.5706 10.4284 14.8506 11.9984 14.8506C13.5684 14.8506 14.8584 13.5706 14.8584 12.0006C14.8584 10.4306 13.5684 9.14062 11.9984 9.14062Z"
        fill="currentColor"
      />
    </svg>
  );
};

const SignupComponent = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    addressLine1: "",
    addressLine2: "",
    phone_no: "",
    phone_code: "",
    email: "",
    password: "",
    password_confirmation: ""
  });
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("in");
  const [isVisible, setIsVisible] = useState(false);
  const [isComfirmPasswordVisible, setIsComfirmPasswordVisible] =
    useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const getLocationDetails = async () => {
    try {
      const result = await trackIP();

      const ip_code = result.data?.country_code;

      if (ip_code) {
        setSelectedCountry(ip_code.toLowerCase());
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: index.js ~ line 70 ~ getLocationDetails ~ error",
        error
      );
    }
  };

  useEffect(() => {
    getLocationDetails();
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!formData.first_name) {
      newErrors.first_name = "First name is required";
    }

    if (!formData.last_name) {
      newErrors.last_name = "Last name is required";
    }

    if (!formData.phone_no) {
      newErrors.phone_no = "Phone number is required";
    } else if (
      !validInternationalPhone(formData.phone_no, formData.phone_code)
    ) {
      newErrors.phone_no = "Please enter a valid phone number";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is not valid";
    }

    if (!formData.addressLine1) {
      newErrors.addressLine1 = "Address Line 1 is required";
    }
    if (!formData.addressLine2) {
      newErrors.addressLine2 = "Address Line 2 is required";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    }
    const passwordLength = 8;

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < passwordLength) {
      newErrors.password = `Password must be at least ${passwordLength} characters long`;
    } else if (!/(?=.*[A-Z])/.test(formData.password)) {
      newErrors.password =
        "Password must include at least one uppercase letter";
    } else if (!/(?=.*[a-z])/.test(formData.password)) {
      newErrors.password =
        "Password must include at least one lowercase letter";
    } else if (!/(?=.*\d)/.test(formData.password)) {
      newErrors.password = "Password must include at least one number";
    } else if (!/(?=.*[@$!%*?&])/.test(formData.password)) {
      newErrors.password =
        "Password must include at least one special character (@$!%*?&)";
    }

    if (formData.password !== formData.password_confirmation) {
      newErrors.password_confirmation = "Passwords do not match";
    }

    if (!acceptTerms) {
      newErrors.acceptTerms = "You must accept the terms and conditions";
    }

    console.log("🚀 ~ validate ~ newErrors:", newErrors);
    return newErrors;
  };

  const [validation, setValidation] = useState({
    first_name: false,
    last_name: false,
    phone_no: false,
    email: false,
    password: false,
    valid_first_name: false,
    valid_last_name: false,
    valid_phone_no: false,
    valid_email: false,
    valid_password: false
  });

  const checkValidation = () => {
    let c_validation = { ...validation };
    if (!formData.first_name) {
      c_validation = { ...c_validation, first_name: true };
    } else {
      if (validateName(formData.first_name)) {
        c_validation = { ...c_validation, valid_first_name: false };
      } else {
        c_validation = { ...c_validation, valid_first_name: true };
      }
    }

    if (!formData.last_name) {
      c_validation = { ...c_validation, last_name: true };
    } else {
      if (validateName(formData.last_name)) {
        c_validation = { ...c_validation, valid_last_name: false };
      } else {
        c_validation = { ...c_validation, valid_last_name: true };
      }
    }
    if (!formData.email) {
      c_validation = { ...c_validation, email: true };
    } else {
      if (validateEmail(formData.email)) {
        c_validation = { ...c_validation, valid_email: false };
      } else {
        c_validation = { ...c_validation, valid_email: true };
      }
    }
    if (!formData.password) {
      c_validation = { ...c_validation, password: true };
    } else if (formData.password === formData.password_confirmation) {
      if (validatePassword(formData.password)) {
        c_validation = { ...c_validation, valid_password: false };
      } else {
        c_validation = { ...c_validation, valid_password: true };
      }
    }
    if (!formData.phone_no) {
      c_validation = { ...c_validation, phone_no: true };
    } else {
      if (validInternationalPhone(formData.phone_no, formData.phone_code)) {
        c_validation = { ...c_validation, valid_phone_no: false };
      } else {
        c_validation = { ...c_validation, valid_phone_no: true };
      }
    }

    setValidation(c_validation);
    if (
      !c_validation.first_name &&
      !c_validation.valid_first_name &&
      !c_validation.last_name &&
      !c_validation.valid_last_name &&
      !c_validation.email &&
      !c_validation.password &&
      !c_validation.phone_no &&
      !c_validation.valid_email &&
      !c_validation.valid_phone_no &&
      !c_validation.valid_password
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        const result = await registerApi(formData);

        if (result.status === 200) {
          navigate("/login");
        }
        setLoading(false);
      } catch (err) {
        if (err?.response?.status === 422) {
          addToast({
            title: err?.response?.data?.errors[0],
            color: "danger",
            variant: "bordered"
          });
        }
        setLoading(false);
      }
    }
  };

  const toggleVisibility = () => setIsVisible(!isVisible);
  const toggleComfirmPasswordVisibility = () =>
    setIsComfirmPasswordVisible(!isComfirmPasswordVisible);

  return (
    <div className="flex flex-col min-h-dvh auth-section-bg h-full justify-center">
      {/* <div className="p-4 lg:px-16">
        <Link to="/" className="block">
          <span className="sr-only">BAF</span>
          <img alt="Logo" src={Logo} className="h-auto w-[6rem] sm:w-[8rem]" />
        </Link>
      </div> */}
      <div className="w-full p-4 pb-8 flex justify-center items-center">
        <div className="max-w-[31rem] mx-auto w-full bg-white rounded-3xl overflow-hidden">
          <div className="py-2 px-4 bg-black">
            <Link to="/" className="block w-fit mx-auto">
              <span className="sr-only">BAF</span>
              <img
                alt="Logo"
                src={Logo}
                className="h-auto w-[6rem] sm:w-[8rem]"
              />
            </Link>
          </div>
          <div className="max-w-[27rem] mx-auto p-4">
            <h2 className="text-3xl font-bold mb-8 text-center">Sign Up</h2>
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
              <div className="flex flex-col md:flex-row gap-4 justify-between">
                <div className="flex flex-col gap-1 flex-1">
                  <Input
                    label=""
                    placeholder="First Name"
                    labelPlacement="outside"
                    type="text"
                    name="first_name"
                    variant="bordered"
                    value={formData.first_name}
                    maxLength={30}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (
                        e.key === " " &&
                        formData.first_name.trim().length === 0
                      ) {
                        e.preventDefault();
                      }
                    }}
                    classNames={{
                      base: "data-[has-label=true]:mt-[calc(0_+_0px)]",
                      label: "hidden",
                      inputWrapper:
                        "border-[#C2C2C2] data-[hover=true]:border-[#C2C2C2] group-data-[focus=true]:border-[#C2C2C2] h-11"
                    }}
                    radius="md"
                  />
                  {errors.first_name && (
                    <small className="text-red-500 text-xs block">
                      {errors.first_name}
                    </small>
                  )}
                </div>

                <div className="flex flex-col gap-1 flex-1">
                  <Input
                    label=""
                    placeholder="Last Name"
                    labelPlacement="outside"
                    type="text"
                    name="last_name"
                    variant="bordered"
                    value={formData.last_name}
                    maxLength={30}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (
                        e.key === " " &&
                        formData.last_name.trim().length === 0
                      ) {
                        e.preventDefault();
                      }
                    }}
                    classNames={{
                      base: "data-[has-label=true]:mt-[calc(0_+_0px)]",
                      label: "hidden",
                      inputWrapper:
                        "border-[#C2C2C2] data-[hover=true]:border-[#C2C2C2] group-data-[focus=true]:border-[#C2C2C2] h-11"
                    }}
                    radius="md"
                  />
                  {errors.last_name && (
                    <small className="text-red-500 text-xs block">
                      {errors.last_name}
                    </small>
                  )}
                </div>
              </div>

              <div className="flex flex-col gap-1">
                <InputPhone
                  defaultCountry={selectedCountry}
                  value={formData.phone_no}
                  required={validation.phone_no}
                  onChange={(phone, data) => {
                    if (typeof phone === "string") {
                      setFormData({
                        ...formData,
                        phone_no: phone,
                        phone_code: data.countryCode?.toUpperCase() || "IN"
                      });
                    }
                  }}
                />
                {errors.phone_no && (
                  <small className="text-red-500 text-xs block">
                    {errors.phone_no}
                  </small>
                )}
              </div>

              <div className="flex flex-col gap-1">
                <Input
                  label=""
                  labelPlacement="outside"
                  type="email"
                  variant="bordered"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  maxLength={50}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    if (e.key === " " && formData.email.trim().length === 0) {
                      e.preventDefault();
                    }
                  }}
                  classNames={{
                    base: "data-[has-label=true]:mt-[calc(0_+_0px)]",
                    label: "hidden",
                    inputWrapper:
                      "border-[#C2C2C2] data-[hover=true]:border-[#C2C2C2] group-data-[focus=true]:border-[#C2C2C2] h-12"
                  }}
                  radius="md"
                />
                {errors.email && (
                  <small className="text-red-500 text-xs block">
                    {errors.email}
                  </small>
                )}
              </div>

              <div className="flex flex-col gap-1">
                <Textarea
                  label=""
                  labelPlacement="outside"
                  id="address1"
                  name="addressLine1"
                  placeholder="Address Line 1"
                  value={formData.addressLine1}
                  onChange={(e) => {
                    let value = e.target.value;

                    let lines = value.split("\n");

                    if (lines.length > 4) {
                      lines = lines.slice(0, 4);
                    }

                    lines = lines.map((line) => line.slice(0, 50));

                    value = lines.join("\n");

                    setFormData({ ...formData, addressLine1: value });
                  }}
                  onKeyDown={(e) => {
                    // Prevent starting with a space
                    if (
                      e.key === " " &&
                      formData.addressLine1.trim().length === 0
                    ) {
                      e.preventDefault();
                    }
                  }}
                  classNames={{
                    base: "data-[has-label=true]:mt-[calc(0_+_0px)]",
                    label: "hidden",
                    inputWrapper:
                      "border-[#C2C2C2] data-[hover=true]:border-[#C2C2C2] group-data-[focus=true]:border-[#C2C2C2] h-12"
                  }}
                  variant="bordered"
                  radius="md"
                />
                {errors.addressLine1 && (
                  <small className="text-red-500 text-xs block">
                    {errors.addressLine1}
                  </small>
                )}
              </div>

              <div className="flex flex-col gap-1">
                <Textarea
                  label=""
                  labelPlacement="outside"
                  id="address2"
                  name="addressLine2"
                  placeholder="Address Line 2"
                  value={formData.addressLine2}
                  onChange={(e) => {
                    let value = e.target.value;

                    let lines = value.split("\n");

                    if (lines.length > 4) {
                      lines = lines.slice(0, 4);
                    }

                    lines = lines.map((line) => line.slice(0, 50));

                    value = lines.join("\n");
                    setFormData({ ...formData, addressLine2: value });
                  }}
                  onKeyDown={(e) => {
                    if (
                      e.key === " " &&
                      formData.addressLine2.trim().length === 0
                    ) {
                      e.preventDefault();
                    }
                  }}
                  classNames={{
                    base: "data-[has-label=true]:mt-[calc(0_+_0px)]",
                    label: "hidden",
                    inputWrapper:
                      "border-[#C2C2C2] data-[hover=true]:border-[#C2C2C2] group-data-[focus=true]:border-[#C2C2C2] h-12"
                  }}
                  variant="bordered"
                  radius="md"
                />
                {errors.addressLine2 && (
                  <small className="text-red-500 text-xs block">
                    {errors.addressLine2}
                  </small>
                )}
              </div>

              <div className="flex flex-col gap-1">
                <Input
                  endContent={
                    <button
                      aria-label="toggle password visibility"
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <EyeSlashFilledIcon className="text-2xl text-default-400 pointer-events-none" />
                      ) : (
                        <EyeFilledIcon className="text-2xl text-default-400 pointer-events-none" />
                      )}
                    </button>
                  }
                  label=""
                  type={isVisible ? "text" : "password"}
                  labelPlacement="outside"
                  variant="bordered"
                  name="password"
                  placeholder="Create Password"
                  value={formData.password}
                  maxLength={42}
                  onChange={handleChange}
                  classNames={{
                    base: "data-[has-label=true]:mt-[calc(0_+_0px)]",
                    label: "hidden",
                    inputWrapper:
                      "border-[#C2C2C2] data-[hover=true]:border-[#C2C2C2] group-data-[focus=true]:border-[#C2C2C2] h-12"
                  }}
                  radius="md"
                />
                {errors.password && (
                  <small className="text-red-500 text-xs block">
                    {errors.password}
                  </small>
                )}
              </div>

              <div className="flex flex-col gap-1">
                <Input
                  endContent={
                    <button
                      aria-label="toggle password visibility"
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleComfirmPasswordVisibility}
                    >
                      {isComfirmPasswordVisible ? (
                        <EyeSlashFilledIcon className="text-2xl text-default-400 pointer-events-none" />
                      ) : (
                        <EyeFilledIcon className="text-2xl text-default-400 pointer-events-none" />
                      )}
                    </button>
                  }
                  label=""
                  type={isComfirmPasswordVisible ? "text" : "password"}
                  labelPlacement="outside"
                  variant="bordered"
                  name="password_confirmation"
                  placeholder="Confirm Password"
                  value={formData.password_confirmation}
                  maxLength={42}
                  onChange={handleChange}
                  classNames={{
                    base: "data-[has-label=true]:mt-[calc(0_+_0px)]",
                    label: "hidden",
                    inputWrapper:
                      "border-[#C2C2C2] data-[hover=true]:border-[#C2C2C2] group-data-[focus=true]:border-[#C2C2C2] h-12"
                  }}
                  radius="md"
                />
                {errors.password_confirmation && (
                  <small className="text-red-500 text-xs block">
                    {errors.password_confirmation}
                  </small>
                )}
              </div>

              <div className="flex items-start gap-2 mb-1">
                <input
                  type="checkbox"
                  id="terms"
                  checked={acceptTerms}
                  onChange={() => setAcceptTerms(!acceptTerms)}
                  className="mt-1"
                />
                <label htmlFor="terms" className="text-sm">
                  I agree to BAFs{" "}
                  <Link
                    to="/terms-and-conditions"
                    target="_blank"
                    className="text-blue-600 underline"
                  >
                    Terms and Conditions
                  </Link>
                </label>
              </div>
              {errors.acceptTerms && (
                <p className="text-red-500 text-sm">{errors.acceptTerms}</p>
              )}

              <Button
                type="submit"
                isDisabled={loading}
                isLoading={loading}
                className="bg-yellowbuy border border-black rounded-lg"
              >
                {loading ? "Loading" : "Sign Up"}
              </Button>
            </form>

            <p className="text-xs text-gray-500 text-center m-0 mt-4">
              Already have an account?{" "}
              <Link to={"/login"} className="text-[#9747FF]">
                Login
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupComponent;
